<span *ngIf="country !== 'Reserved'"
  ><img
    width="20"
    height="10"
    style="vertical-align: baseline"
    src="https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/2.8.0/flags/1x1/{{
      code | lowercase
    }}.svg"
  />
  {{ country }}</span
><span *ngIf="country === 'Reserved' && showUnknownCountry">Unknown</span>
